import { createContext } from 'react'

type ToastType = 'success' | 'error' | 'warning' | 'info'

export interface ToastContextValue {
  toast: (type: ToastType, message: string, duration?: number) => void
}

export const ToastContext = createContext<ToastContextValue | null>(null)
